import React from "react";
import { Box, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

function DocumentClassifierPanel({ onOpenFolderDialog }) {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        marginRight: 5,
      }}
    >
      <Box
        sx={{
          backgroundColor: "rgba(0, 71, 171,0.8)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
          height: 650,
          width: 700,
          marginBottom: 5,
          borderRadius: 5,
          marginLeft: 0,
          opacity: 0,
          transform: "translateX(100px)",
          animation: "slideInLeft 1s ease-out forwards",
          "@keyframes slideInLeft": {
            from: {
              opacity: 0,
              transform: "translateX(100px)",
            },
            to: {
              opacity: 1,
              transform: "translateX(0)",
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <SearchIcon
            sx={{
              fontSize: 600,
              color: "rgb(255, 255, 240, 0.7)",
              boxShadow: "10px rgb(22, 22, 21)",
            }}
          />
        </Box>
      </Box>
      <Button
        variant="contained"
        onClick={onOpenFolderDialog}
        sx={{
          width: 300,
          height: 100,
          fontSize: 20,
          fontWeight: "bold",
          borderRadius: 6,
          boxShadow: 4,
          color: "#202020",
          backgroundImage:
            "linear-gradient(to bottom, #F7ECD7,rgb(237, 227, 208))",
          "&:hover": {
            boxShadow: 8,
          },
          opacity: 0,
          animation: "fadeIn 1s ease-in-out forwards",
          animationDelay: "0.6s",
          "@keyframes fadeIn": {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        }}
      >
        Document Classifier
      </Button>
    </Box>
  );
}

export default DocumentClassifierPanel;
